/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './grantVerifications.defs.js'
export { main as default } from './grantVerifications.defs.js'
